import { render, staticRenderFns } from "./charterer.vue?vue&type=template&id=1c2ccfe6"
import script from "./charterer.vue?vue&type=script&lang=js"
export * from "./charterer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports